var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplacementBus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-icon_replacement-bus",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6004_5530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 0.5H21C22.3807 0.5 23.5 1.61929 23.5 3V21C23.5 22.3807 22.3807 23.5 21 23.5H3C1.61929 23.5 0.5 22.3807 0.5 21V3C0.5 1.61929 1.61929 0.5 3 0.5Z",
    fill: "white",
    stroke: "#DC0451"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0749 2.40039H5.92592C5.25535 2.40039 4.71094 2.94396 4.71094 3.61538V18.1944C4.71094 18.8649 5.25443 19.4093 5.92578 19.4094V21.6006H7.78594V19.4094H16.2148V21.6006H18.075V19.4094C18.7455 19.4093 19.2899 18.8658 19.2899 18.1944V3.61538C19.2891 2.94396 18.7455 2.40039 18.0749 2.40039ZM9.29994 3.48583H14.7001V4.40025H9.29994V3.48583ZM6.85558 17.2317C6.34164 17.2317 5.92592 16.8151 5.92592 16.302C5.92592 15.7881 6.34249 15.3724 6.85558 15.3724C7.36951 15.3724 7.78523 15.7889 7.78523 16.302C7.78608 16.8151 7.36951 17.2317 6.85558 17.2317ZM17.1444 17.2317C16.6305 17.2317 16.2148 16.8151 16.2148 16.302C16.2148 15.7881 16.6313 15.3724 17.1444 15.3724C17.6584 15.3724 18.0741 15.7889 18.0741 16.302C18.0749 16.8151 17.6584 17.2317 17.1444 17.2317ZM18.0749 12.3777C18.0749 12.5978 17.9276 12.79 17.7151 12.8467C16.8684 13.0745 14.6222 13.602 12 13.602C9.37784 13.602 7.1316 13.0745 6.28492 12.8467C6.0724 12.79 5.92508 12.5978 5.92508 12.3777V5.79389C5.92508 5.52549 6.14267 5.30789 6.41107 5.30789H17.5881C17.8565 5.30789 18.0741 5.52549 18.0741 5.79389V12.3777H18.0749Z",
    fill: "#DC0451"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6004_5530"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplacementBus);
export default __webpack_public_path__ + "static/media/replacement-bus.c3a47a7dee50499ad8b94e97c3e24167.svg";
export { ForwardRef as ReactComponent };